import T from '../localization/LocalizationKeys';
import _ from 'lodash';
import { PRIMITIVE_SCHEMAS } from '../utils/dtdl';

export const Aggregation = Object.freeze({
  MEAN: 'avg',
  MIN: 'min',
  MAX: 'max',
  FIRST: 'first',
  LAST: 'last',
  SUM: 'sum',
  MEDIAN: 'median'
});

export const TimeUnits = {
  MINUTE: 'minutes',
  HOUR: 'hours',
  DAY: 'days',
  WEEK: 'weeks',
  MONTH: 'months',
  YEAR: 'years'
};

export const DayUnits = {
  TODAY: 'Today',
  YESTERDAY: 'Yesterday'
};

export const DayUnitsTranslation = {
  [DayUnits.TODAY]: T.common.dayunits.today,
  [DayUnits.YESTERDAY]: T.common.dayunits.yesterday
};


export const TimeUnitsTranslation = {
  [TimeUnits.MINUTE]: T.common.timeunits.minutes,
  [TimeUnits.HOUR]: T.common.timeunits.hours,
  [TimeUnits.DAY]: T.common.timeunits.days,
  [TimeUnits.WEEK]: T.common.timeunits.weeks,
  [TimeUnits.MONTH]: T.common.timeunits.months,
  [TimeUnits.YEAR]: T.common.timeunits.years
};

// Map object values to translation key
const translateObject = (object, translationArray) => _.reduce(object, (result, key) =>
  ({ ...result, [key]: translationArray[_.toLower(key)] }), {});

export const AggregationTranslation = translateObject(Aggregation, T.common.aggregations);

export const TimeBucket = Object.freeze({
  RAW: 'RAW',
  PT1M: 'PT1M',
  PT5M: 'PT5M',
  PT15M: 'PT15M',
  PT1H: 'PT1H',
  PT12H: 'PT12H',
  P1D: 'P1D',
  P1M: 'P1M'
});

export const TimeBucketTranslation = translateObject(TimeBucket, T.common.timebuckets);

export const TimeOffset = Object.freeze({
  T30MIN: 't30min',
  T1HOUR: 't1hour',
  T6HOURS: 't6hours',
  T12HOURS: 't12hours',
  T24HOURS: 't24hours',
  T7DAYS: 't7days',
  T30DAYS: 't30days',
  T90DAYS: 't90days',
  T1YEAR: 't1year'
});

export const TimeOffsetToMinutes = Object.freeze({
  [TimeOffset.T30MIN]: 30,
  [TimeOffset.T1HOUR]: 60,
  [TimeOffset.T6HOURS]: 6 * 60,
  [TimeOffset.T12HOURS]: 12 * 60,
  [TimeOffset.T24HOURS]: 24 * 60,
  [TimeOffset.T7DAYS]: 7 * 24 * 60,
  [TimeOffset.T30DAYS]: 30 * 24 * 60,
  [TimeOffset.T90DAYS]: 90 * 24 * 60,
  [TimeOffset.T1YEAR]: 365 * 24 * 60
});

export const TimeOffsetTranslation = translateObject(TimeOffset, T.common.timeoffsets);

export const NUMBERS_ONLY_SCHEMA = [PRIMITIVE_SCHEMAS.double, PRIMITIVE_SCHEMAS.integer, PRIMITIVE_SCHEMAS.long, PRIMITIVE_SCHEMAS.float, PRIMITIVE_SCHEMAS.double];

const everythingButRawTimeBucket = Object.values(TimeBucket).filter(timeBucket => timeBucket !== TimeBucket.RAW);

const numberOnlyAggregationData = {
  schemas: NUMBERS_ONLY_SCHEMA,
  timeBuckets: everythingButRawTimeBucket
};

const allAggregationData = {
  schemas: Object.values(PRIMITIVE_SCHEMAS),
  timeBucket: everythingButRawTimeBucket
};

export const aggregationData = {
  [Aggregation.MEAN]: numberOnlyAggregationData,
  [Aggregation.MIN]: numberOnlyAggregationData,
  [Aggregation.MAX]: numberOnlyAggregationData,
  [Aggregation.SUM]: numberOnlyAggregationData,
  [Aggregation.MEDIAN]: numberOnlyAggregationData,
  [Aggregation.FIRST]: allAggregationData,
  [Aggregation.LAST]: allAggregationData
};

const everythingButAllData = {
  schemas: Object.values(PRIMITIVE_SCHEMAS),
  aggregation: Object.values(Aggregation)
};

export const timeBucketData = {
  [TimeBucket.RAW]: {
    schemas: Object.values(PRIMITIVE_SCHEMAS),
    aggregation: []
  },
  [TimeBucket.PT1M]: everythingButAllData,
  [TimeBucket.PT5M]: everythingButAllData,
  [TimeBucket.PT15M]: everythingButAllData,
  [TimeBucket.PT1H]: everythingButAllData,
  [TimeBucket.PT12H]: everythingButAllData,
  [TimeBucket.P1D]: everythingButAllData,
  [TimeBucket.P1M]: everythingButAllData
};

export const DefaultLaneNumber = 0;

export const DefaultDecimalPoints = 2;

export const PromiseAllSettledSuccessStatus = 'fulfilled';

